import axios, { AxiosResponse } from "axios";
import { isEmpty, isNil } from "lodash";
import { ApiRouteParameter } from "./WebApiTypes";



class TrackerApi {
    token: string;
    base: string;
    config: any;
    devRomanVersion: string;

    constructor() {
        this.token = ""
        // this.base = "https://zelda-randomizer-api.azurewebsites.net"
        this.base = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://localhost:34465" : "https://zelda-randomizer-api.azurewebsites.net";
        this.setConfig()
        this.devRomanVersion = "devR_7.1.118"
    }

    // ==================
    // HELPERS
    // ==================

    setConfig() {
        this.config = {
            headers: { Authorization: `Bearer ${this.token}`, 'Access-Control-Allow-Origin': '*' },
            withCredentials: true
        };
    }

    hasToken(): boolean {
        return this.token !== ""
    }

    resetToken() {
        this.updateToken("")
    }

    updateToken(token: string) {
        this.token = token;
        this.setConfig()
    }

    // standard controllers
    // ====================

    async callServiceGet(route: string, params?: Array<ApiRouteParameter>): Promise<any> {

        let url = this.base + route;

        if (!isNil(params) && !isEmpty(params)) {
            url += "?"
            params.forEach((param) => {
                url += param.name + "=" + param.value + "&";
            })
            url = url.slice(0, url.length - 1);
        }

        let response = await axios.get(url, this.config)

        return response.data;
    }

    async callServicePost(route: string, data: any = {}): Promise<any> {
        let response = await axios.post(this.base + route, data, {
            headers: { Authorization: `Bearer ${this.token}`, }
        });
        return response.data;
    }

    async callServiceGetById(route: string, id: number): Promise<any> {
        let response = await axios.get(this.base + route + '/' + id, this.config);
        return response.data;
    }

    async callServicePut(route: string, id: number, data: any): Promise<any> {
        let response = await axios.put(this.base + route + "/" + id, data, this.config);
        return response.data;
    }

    async callServicePatch(route: string, data: any): Promise<any> {
        let response = await axios.patch(this.base + route, data, this.config);
        return response.data;
    }

    async callServicePartialPatch(id: string, route: string, data: any): Promise<any> {
        let response = await axios.patch(this.base + route + "/" + id, data, this.config);
        return response.data;
    }

    async callServiceDelete(route: string, id: number | string): Promise<any> {
        let response = await axios.delete(this.base + route + '/' + id, this.config);
        return response.data;
    }

    async callServiceGetByIdString(route: string, id: string): Promise<any> {
        let response = await axios.get(this.base + route + '/' + id, this.config);
        return response.data;
    }

    async callServicePutString(route: string, id: string, data: any): Promise<any> {
        let response = await axios.put(this.base + route, data, this.config);
        return response.data;
    }

    async callServiceDeleteString(route: string, id: string): Promise<any> {
        let response = await axios.delete(this.base + route, this.config);
        return response.data;
    }


    // DOWNLOAD FILE - GET
    // ===============================================================
    async DownloadFileGetAsync(url: string): Promise<any> {
        let response = await axios.get(this.base + url, {
            responseType: 'blob'
        });
        return response;
    }

    // DOWNLOAD FILE - POST
    // ===============================================================
    async DownloadFilePostAsync(url: string, data?: any): Promise<any> {
        let response = await axios.post(this.base + url, data, {
            responseType: 'blob'
        });
        return response;
    }

    //UploadFile Post
    async UploadFileWithResultFileAsync(
        file: File,
        name: string,
        url: string
    ): Promise<AxiosResponse<any, any>> {

        var formData = new FormData();
        formData.append(name, file);

        let response = await axios.post(
            this.base + url,
            formData,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + this.token
                },

            }
        );
        return response;
    }

}

export let trackerApi = new TrackerApi();